<template>
  <new-dispatch />
</template>

<script>
import NewDispatch from "@/components/3pl/Operations/Dispatch/newdispatch/NewDispatch";

export default {
  components: {
    NewDispatch,
  },
};
</script>

<style></style>
